import { useEffect, useState } from 'react';
import useLeaderboardData from './useLeaderboardData';
export default function useLeaderboardHasScores(url) {
    var _a = useState(false), hasScores = _a[0], setHasScores = _a[1];
    var data = useLeaderboardData(url).data;
    useEffect(function () {
        if (data && !hasScores) {
            var hasScoresUpdated = (data === null || data === void 0 ? void 0 : data.primary.players.some(function (p) { return p.rounds.length > 0; })) === true;
            setHasScores(hasScoresUpdated);
        }
    }, [data, hasScores]);
    return hasScores;
}
